/* __next_internal_client_entry_do_not_use__ SearchTileEffects auto */ import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useAssignPersistQuickAddOnSearchTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TileEffects/useAssignPersistQuickAddOnSearchTile";
import React from "react";
export var SearchTileEffects = function() {
    useAssignPersistQuickAddOnSearchTile();
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
